interface CreateAPIOptions {
  getHostname(): string
  getUrl(): string | null
}

export const createApiResolver = ({
  getHostname,
  getUrl,
}: CreateAPIOptions) => ({
  getUrl: () => getUrl() || getHostname(),
})

const getEnvApiHostname = () => {
  if (!process.env.REACT_APP_IS_WITH_PROXY && process.env.REACT_APP_API_URL) {
    // NOTE: this is silly condition for our staging env, this should be set in build process
    if (window.location.host.includes('app.staging.surglogs.com')) {
      return `${window.location.protocol}//api.staging.surglogs.com`
    }

    return process.env.REACT_APP_API_URL
  }

  if (window.location.host.includes('app')) {
    return window.location.host.replace('app', 'api')
  }

  return `//${window.location.host}`
}

export const EnvApiResolver = createApiResolver({
  getHostname: getEnvApiHostname,
  getUrl: (scope = window.localStorage) => scope.getItem('API_URL'),
})
